import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { DeleteTemplateScreensMutation, DeleteTemplateScreensMutationVariables } from '@/graphql/generated/graphql';
import { DeleteTemplateScreensDocument } from '@/graphql/generated/graphql';
export type DeleteTemplateScreenInput = {
  ItemId: string
  isHardDelete?: boolean
}

export type DeleteTemplateScreenResponse = {
  data: {
    deleteTemplateScreens: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useDeleteTemplateScreen = () => {
  const mutation = useMutation({
    mutationKey: ['delete-template-screen'],
    mutationFn: ({ ItemId, isHardDelete = false }: DeleteTemplateScreenInput) => {
      return graphqlClient.request<DeleteTemplateScreensMutation>(DeleteTemplateScreensDocument,
        { ItemId, isHardDelete }
      )
    }
  })

  return {
    ...mutation,
    deleteTemplateScreen: mutation.mutate,
    deleteTemplateScreenAsync: mutation.mutateAsync,
  }
}

export const DELETE_TEMPLATE_SCREEN_MUTATION = DeleteTemplateScreensDocument;
